import { BaseInput } from './base-input';

export class DecimalInput extends BaseInput {
  public constructor(data: any) {
    super(data);
  }
}
